import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import DocumentReuseable from '@/components/document-reuseable';
import { getDocumentHomePages, getPageDocument, getProducts } from '@/services/apis';

export default function DocumentDetailEng({
  initDocument = [],
  initDocumentHomePage = [],
  initProductData = [],
}) {
  return (
    <DocumentReuseable
      initDocument={initDocument}
      initDocumentHomePage={initDocumentHomePage}
      initProductData={initProductData}
    />
  );
}

export async function getServerSideProps(context) {
  const productId = context?.params?.productId || '';
  const isDocumentHomePage = productId?.length === 2;

  let initDocument = [];
  let initDocumentHomePage = [];
  let initProductData = [];
  try {
    if (productId?.length === 1) {
      initProductData = await getProducts({ slug: productId[0], locale: context?.locale });
    } else if (!isDocumentHomePage) {
      initDocument = await getPageDocument({
        featureSlug: productId?.[2],
        locale: context?.locale,
        productSlug: productId?.[0],
      });
    } else {
      initDocumentHomePage = await getDocumentHomePages({
        productSlug: productId?.[0],
        documentSlug: productId?.[1],
        locale: context?.locale,
      });
    }

    return {
      props: {
        ...(await serverSideTranslations(context?.locale, [
          'header',
          'footer',
          'common',
          'messages',
          'news',
          'document',
        ])),
        initDocument,
        initDocumentHomePage,
        initProductData,
      },
    };
  } catch (error) {
    return { notFound: true };
  }
}
